<template>
  <v-container>
    <v-row class="ma-0" no-gutters>
      <v-col>
        <StaticBannerWithCurvedCard />
        <Benefits />
        <Promotions :loading="loadingPromotions" :promotions="promotions" />

        <v-row class="ma-0 px-2" justify="center">
          <v-col cols="12" md="10">
            <BlogEvents v-if="!breakpointSmAndDown" class="mt-4" />

            <v-row no-gutters>
              <v-col
                class="mt-1 mt-md-4"
                cols="12"
                :order="productFocused ? 1 : 2"
              >
                <AllCategories :wrap="true" />
              </v-col>
              <!-- <v-col
                class="mt-1 mt-md-4"
                cols="12"
                :order="productFocused ? 2 : 1"
              >
                <AllActivities />
              </v-col> -->
            </v-row>

            <v-col cols="12" order="2" class="pa-0 mt-1 mt-md-4">
              <TrendingProducts v-if="productFocused" />
              <TrendingEvents v-else />
            </v-col>

            <BlogEvents v-if="breakpointSmAndDown" class="mt-6" />
            <ActivityCalendar class="mt-4" />
            <Reviews class="mt-4" />
            <TemplateEvents class="mt-4" />
            <AppDownloadButtons class="mt-4" />
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import homePageMixin from '@/mixins/homePage';
import StaticBannerWithCurvedCard from '@/components/homepage/StaticBannerWithCurvedCard';
import Promotions from '@/components/homepage/Promotions';
import AllCategories from '@/components/homepage/AllCategories.vue';
import ActivityCalendar from '@/components/homepage/ActivityCalendar.vue';
import Benefits from '@/components/homepage/Benefits.vue';
import BlogEvents from '@/components/homepage/BlogEvents.vue';
import Reviews from '@/components/homepage/Reviews.vue';
import TemplateEvents from '@/components/homepage/TemplateEvents.vue';
import AppDownloadButtons from '@/components/homepage/appDownload/AppDownloadButtons.vue';

export default {
  name: 'StoryView',
  mixins: [homePageMixin],
  components: {
    StaticBannerWithCurvedCard,
    Promotions,
    AllCategories,
    ActivityCalendar,
    Benefits,
    BlogEvents,
    Reviews,
    TemplateEvents,
    AppDownloadButtons,
    TrendingProducts: () =>
      import('@/components/homepage/trendingProducts/TrendingProducts.vue'),
    TrendingEvents: () =>
      import('@/components/homepage/trendingEvents/TrendingEvents.vue'),
  },
};
</script>
